import { MembershipConfigPanel } from "../components/MembershipConfigPanel";
import { MembershipPageHeader } from "../components/MembershipPageHeader";

export default function MembershipConfigPage() {
  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <MembershipPageHeader
        title="Membership Configuration"
      />

      <MembershipConfigPanel />
    </div>
  );
}